const Results = ({ results, handleOnResultClick }) => (
  <ul className="resultsContainer">
    {results.map((el, index) => (
      <li key={el.videoId}>
        <div
          className={"imgAndTitleContainer"}
          onClick={() => handleOnResultClick(el, index)}
        >
          <img
            alt=""
            src={"https://i.ytimg.com/vi/" + el.videoId + "/default.jpg"}
          />
          <div className="metaContainer">
            <span>{el.title}</span>
            {el.duration.timestamp ? (
              <span>{el.duration.timestamp}</span>
            ) : null}
            {el.views ? <span>Views : {el.views}</span> : null}
          </div>
        </div>
      </li>
    ))}
  </ul>
);

export default Results;
